import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Estatus, UsuarioAutorizado, Impactos } from 'src/app/interfaces/interfaces';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { MatDialog} from '@angular/material/dialog';
import { almenosUnImpactoValidator } from 'src/app/validators/validadores.validator';
import { ModalCosteoConsultaComponent } from 'src/app/components/modal-costeo-consulta/modal-costeo-consulta.component';


import { IniciativaDetalle } from '../../models/iniciativa';
@Component({
  selector: 'app-modal-iniciativa',
  templateUrl: './modal-iniciativa.component.html',
  styleUrls: ['./modal-iniciativa.component.scss']
})
export class ModalIniciativaComponent implements OnInit {
  @Input() iniciativa: any;
 arrayImpactosConsulta: Impactos[]=[];

  @Input() modalAdministrador: boolean;
  @Input() modalLider: boolean;
  @Output() tablaIniciativas: EventEmitter<number>;
  
  emailUsuario: string;
  VIP: boolean = false;
  editando: boolean;
  periodoEnvio: boolean;
  // forms para procesos posibles
  formEditar: FormGroup;
  formCancelacion: FormGroup;
  // Lista de estatus para flujo despues de aceptar una iniciativa
  estatusFlujo: Estatus[];
  // Motivos
  motivosCancelacion: Estatus[];
  motivosRechazo: Estatus[];
  motivosSuspencion: Estatus[];
  // Visivilidad de los uploadings de los archivos
  subiendoProcesoActual = false;
  subiendoProcesoPropuesto = false;
  subiendoCosteo = false;
  subiendoOtrosArchivos = false;
  procesoActualError = false;
  procesoPropuestoError = false;
  costeoError = false;
  otrosArchivosError = false;
  // Asignacion de lideres
  listaLideres: UsuarioAutorizado[] = [];
  // Valores de los input Files
  @ViewChild('procesoActual')
  procesoActualInput: ElementRef;
  @ViewChild('procesoPropuesto')
  procesoPropuestoInput: ElementRef;
  @ViewChild('costeo')
  costeoInput: ElementRef;
  @ViewChild('otrosArchivos')
  otrosArchivosInput: ElementRef;
  @ViewChild('procesoActualLabel')
  procesoActualLabel: ElementRef;
  @ViewChild('procesoPropuestolLabel')
  procesoPropuestolLabel: ElementRef;
  @ViewChild('costeoLabel')
  costeoLabel: ElementRef;
  @ViewChild('otrosArchivosLabel')
  otrosArchivolLabel: ElementRef;
  @ViewChild('botonCerrarModal')
  botonCerrarModal: ElementRef;
  // Mensajes de errores para la subida de archivos
  procesoActualErrorMsg: string;
  procesoPropuestoErrorMsg: string;
  costeoErrorMsg: string;
  otrosArchivosErrorMsg: string;
  // Limite para campo fecha
  fechaActual: number;
  nombreArchivoPA:string;
  nombreArchivoPP:string;
  nombreArchivoAN:string;
  mostrarFormConsultar:boolean=false;

  

  get fc() {
    return this.formEditar.controls;
  }

  get fcc() {
    return this.formCancelacion;
  }

  constructor(private dataService: DataService,public dialog:MatDialog,
    private notifier: NotifierService,
    private authService: AuthService) {
    this.fechaActual = Date.now();
    this.tablaIniciativas = new EventEmitter();
    this.editando = false;
    this.periodoEnvio = true;
    this.authService.user.subscribe(user => {
      this.emailUsuario = user;
    });
    this.authService.isVIP.asObservable().subscribe((res) => {
      this.VIP = res;
    });
    //this.periodoEnvio = this.dataService.esPeriodoEnvios();
  }

  ngOnInit() 
  {
    /*this.dataService.obtenerMotivosCancelacion().subscribe(res => {
      this.motivosCancelacion = res['data'];
    }, error => {
      console.error(error);
    });

    this.dataService.obtenerMotivosRechazo().subscribe(res => {
      this.motivosRechazo = res['data'];
    }, error => {
      console.error(error);
    });

    this.dataService.obtenerMotivosSuspencion().subscribe(res => {
      this.motivosSuspencion = res['data'];
    });*/

    this.formEditar = new FormGroup({
      idIniciativa: new FormControl(''),
      cuenta: new FormControl(this.emailUsuario),
      nombreSistema: new FormControl('', [Validators.required]),
      problematica: new FormControl('', [Validators.required]),
      NombreCambioCorreccion: new FormControl('', [Validators.required]),
      fechaTermino: new FormControl('', [Validators.required]),
      justificacion: new FormControl('', [Validators.required]),
      solucion: new FormControl('', [Validators.required]),
      beneficiariosDirectos: new FormControl('', [Validators.required]),
      beneficiariosImplementacion: new FormControl('', [Validators.required]),
      procesoActual: new FormControl('', [Validators.required]),
      procesoPropuesto: new FormControl('', [Validators.required]),
      costeo: new FormControl('', [Validators.required]),
      otrosArchivos: new FormControl(''),
      impactos: new FormGroup({
        contribucionProgGobierno: new FormControl(''),
        contribucionProgOperativo: new FormControl(''),
        impactoProcesos: new FormControl(''),
        mejoraServicio: new FormControl(''),
        cumplimientoLey: new FormControl(''),
        contribucionModernizacion: new FormControl('')
      }, almenosUnImpactoValidator())
    });

    this.formCancelacion = new FormGroup({
      idIniciativa: new FormControl(''),
      cuenta: new FormControl(''),
      idEstatusPadre: new FormControl(''),
      idEstatusHijos: new FormControl('', [Validators.required]),
      observaciones: new FormControl('', [Validators.required]),
    });
  }


  modalCerrado() {
    this.editando = false;
    this.formCancelacion.reset();
    this.formEditar.reset();
  }

  cancelar(){}

  descargarArchivo(archivo:string)
  {
    this.dataService.descargarArchivo(parseInt(this.iniciativa.id_iniciativa),archivo).subscribe(res => {
      // Este es necesario para crear un objeto blob con el tipo de archivo
      // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
      let newBlob = new Blob([res], { type: this.obtenerTipoArchivo(archivo) });
      // IE no permite objetos blob directamente en el atributo href de un link
      // en su lugar hay que usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
       let link = document.createElement('a');
      link.href = data;
      link.download = archivo.substring(36);
      // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);

    });

  }

  private obtenerTipoArchivo(archivo: string): string {
    let tipoArchivo: string;
    let extencion: string = archivo.split('.').pop();

    switch (extencion) {
      case 'pdf':
        tipoArchivo = 'application/pdf';
        break;
      case 'xls':
        tipoArchivo = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'csv':
        tipoArchivo = 'application/csv';
        break;
      case 'zip':
        tipoArchivo = 'application/zip';
        break;
      case 'rar':
        tipoArchivo = 'application/x-rar-compressed';
        break;

      default:
        tipoArchivo = 'text/plain';
        break;
    }
    return tipoArchivo;
  }

    //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalCosteoConsulta()
 { 
  
   const dialogRef = this.dialog.open(ModalCosteoConsultaComponent,{data:{id_iniciativa:this.iniciativa.id_iniciativa,id_proceso:this.iniciativa.idProceso},disableClose:false, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
     }
     else{
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

}
